<template>
  <header class="flex items-center justify-center gap-2 pb-6" aria-label="Moxso">
    <img src="/assets/moxso-logo.svg" alt="" class="h-6" />
    <img src="/assets/moxso-wordmark.svg" alt="Moxso" class="h-4" />
  </header>
</template>
